"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNursysTransactionLicenseDto = instanceOfNursysTransactionLicenseDto;
exports.NursysTransactionLicenseDtoFromJSON = NursysTransactionLicenseDtoFromJSON;
exports.NursysTransactionLicenseDtoFromJSONTyped = NursysTransactionLicenseDtoFromJSONTyped;
exports.NursysTransactionLicenseDtoToJSON = NursysTransactionLicenseDtoToJSON;
exports.NursysTransactionLicenseDtoToJSONTyped = NursysTransactionLicenseDtoToJSONTyped;
/**
 * Check if a given object implements the NursysTransactionLicenseDto interface.
 */
function instanceOfNursysTransactionLicenseDto(value) {
    if (!('licenseId' in value) || value['licenseId'] === undefined)
        return false;
    if (!('licenseNumber' in value) || value['licenseNumber'] === undefined)
        return false;
    if (!('ncsbnId' in value) || value['ncsbnId'] === undefined)
        return false;
    if (!('jurisdiction' in value) || value['jurisdiction'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    return true;
}
function NursysTransactionLicenseDtoFromJSON(json) {
    return NursysTransactionLicenseDtoFromJSONTyped(json, false);
}
function NursysTransactionLicenseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'licenseId': json['licenseId'],
        'licenseNumber': json['licenseNumber'],
        'ncsbnId': json['ncsbnId'],
        'jurisdiction': json['jurisdiction'],
        'data': json['data'],
        'nurseProfileId': json['nurseProfileId'],
    };
}
function NursysTransactionLicenseDtoToJSON(json) {
    return NursysTransactionLicenseDtoToJSONTyped(json, false);
}
function NursysTransactionLicenseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'licenseId': value['licenseId'],
        'licenseNumber': value['licenseNumber'],
        'ncsbnId': value['ncsbnId'],
        'jurisdiction': value['jurisdiction'],
        'data': value['data'],
        'nurseProfileId': value['nurseProfileId'],
    };
}
//# sourceMappingURL=NursysTransactionLicenseDto.js.map